import { Get } from "domain/infra/data/api"
import DomainConstants from "../../infra/data/domainConstants";

import { CarteiraBaseResponse } from 'domain/types/_carteira/carteiraBase/carteiraBaseResponse';
import { CarteiraBaseCampanhaResponse } from 'domain/types/_carteira/carteiraBase/carteiraBaseCampanhaResponse';
import { CarteiraUsuarioResponse } from 'domain/types/_carteira/carteiraBase/carteiraUsuarioResponse';

export class CarteiraBaseService {
  constructor() {
    //super()
  }

  async GetCarteiraBase(carteiraId: number, usuarioId: number): Promise<CarteiraBaseResponse | Error> {
    return await Get(DomainConstants.apiDomain.carteira.getUserInfo(carteiraId, usuarioId))
  }

  async GetCarteiraBasePorCarteira(carteiraId: number, usuarioId: number, campanhaId: number): Promise<CarteiraBaseCampanhaResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.carteira.getUserInfoCampanha(carteiraId, usuarioId, campanhaId)}`);
  }

  async GetCarteiraUsuario(usuarioId: number, empresaId: number): Promise<CarteiraUsuarioResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.carteira.getCarteiraUsuario(usuarioId, empresaId)}`);
  }
}
